export default "__VITE_ASSET__BV1W4ks$__"